var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.788086,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F3E3E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58334 12.2881L9.28176 14.9548L16.0278 8.28809",
    stroke: "#F3674C",
    strokeWidth: 2.72141,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconOrange);
export default __webpack_public_path__ + "static/media/check-icon-orange.91c0c7dc556c14376391c07e84d68df2.svg";
export { ForwardRef as ReactComponent };